import { useEffect, useCallback } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when Form step is changed.
 * @memberOf Playtech.API.events
 * @event dynamic-form-step-changed
 * @type {callback}
 * @param {Object} details
 * @param {string} details.formName Name of the form.
 * @param {number} details.formStep Form step user navigates to.
 * @param {number} details.totalSteps Total count of form steps.
 * @example Playtech.on('dynamic-form-step-changed', ({ formName, formStep, totalSteps }) => { ... });
 */
export const FORM_STEP_CHANGED = 'dynamic-form-step-changed';

export const useOnFormStepChanged = (eventTarget: EventTarget) => {
    const handleEvent = useCallback((data: { formName: string; formStep: number; totalSteps: number }): void => {
        const event = new CustomEvent(FORM_STEP_CHANGED, { detail: data });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('formStepChanged', handleEvent);

        return () => publicEventsAPIService.off('formStepChanged', handleEvent);
    }, [handleEvent]);
};
